import { useTriviaContext } from "../context-trivia";
import { getAnswerGridColumns } from "../trivia-layout";
import type { TriviaAnswerModel } from "../trivia-types";
import { TriviaButton } from "../TriviaButton/TriviaButton";

type TriviaAnswerGridProps = {
  answers: TriviaAnswerModel[];
  hiddenAnswerIds?: string[];
  disabled: boolean;
  selectedAnswerId?: string;
  onSelect: (answer: TriviaAnswerModel) => void;
};

export function TriviaAnswerGrid({
  answers,
  hiddenAnswerIds = [],
  disabled,
  selectedAnswerId,
  onSelect,
}: TriviaAnswerGridProps) {
  const { containerSize } = useTriviaContext();

  const visible = answers.filter((a) => !hiddenAnswerIds.includes(a.id));
  const hasMedia = visible.some((a) => !!a.media);
  const columns = getAnswerGridColumns(
    visible.length,
    containerSize.orientation,
    hasMedia,
  );

  return (
    <div
      className="grid h-full w-full gap-[var(--trivia-space)] overflow-y-auto overflow-x-hidden overscroll-contain"
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {visible.map((answer) => (
        // TriviaButton's props intentionally have no `correct` field — passing individual
        // fields here (not spreading `answer`) is what keeps the correct answer from ever
        // reaching the DOM before the feedback phase, enforced by the type, not discipline.
        <TriviaButton
          key={answer.id}
          variant="answer"
          text={answer.label}
          media={answer.media}
          mediaAlt={answer.mediaAlt}
          disabled={disabled}
          selected={answer.id === selectedAnswerId}
          onHandleMouse={() => onSelect(answer)}
        />
      ))}
    </div>
  );
}
